export var FOUROFOURPAGE_IMAGE_DEFAULT = {
    image: "/assets/img/404_DT.jpg",
    tablet1Image: "/assets/img/404_TP.jpg",
    tablet2Image: "/assets/img/404_TL.jpg",
    mobileImage: "/assets/img/404_Mob.jpg"
}
